<script setup lang="ts">
const userIcon = ref(null);
const props = defineProps({
  size: {
    type: String,
    default: "30px",
  },
  initials: {
    type: String,
    required: false,
    default: "-",
  },
});
/** Expose Ref to Parent **/
defineExpose({ userIcon });

const name = computed(() => {
  if (props.initials) {
    return props.initials.toUpperCase();
  }
  return "-";
});

/** Scale the initials with the circle so they stay legible at larger sizes (~40% of the diameter). */
const fontSize = computed(() => {
  const px = parseInt(props.size, 10);
  return Number.isFinite(px) ? `${Math.round(px * 0.35)}px` : undefined;
});
</script>

<template>
  <button
    ref="userIcon"
    class="small_regular user_circle flex justify-center items-center shrink-0 rounded-[50%] w-[30px] h-[30px] min-w-[30px] min-h-[30px] bg-tag-light-purple-bg text-tag-light-purple-text"
    :style="{ width: props.size, height: props.size, fontSize }"
  >
    {{ name }}
  </button>
</template>
